enum AccountsReceivableListFeeTypeEnum {
  PERCENTAGE = 'percentage',
  FINANCIAL = 'financial',
}

export default AccountsReceivableListFeeTypeEnum;
